"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var APIActionTypeSuffix;
(function (APIActionTypeSuffix) {
    APIActionTypeSuffix["REQUEST"] = "REQUEST";
    APIActionTypeSuffix["SUCCESS"] = "SUCCESS";
    APIActionTypeSuffix["FAILURE"] = "FAILURE";
    APIActionTypeSuffix["CANCEL"] = "CANCEL";
})(APIActionTypeSuffix = exports.APIActionTypeSuffix || (exports.APIActionTypeSuffix = {}));
//# sourceMappingURL=types.js.map